import React, { useState } from "react";
import styles from "./WalletDialog.module.sass";
import ReactModal from "react-modal";
import { Button } from "@/components/Button";
import ModalCloser from "@/assets/capybara-images/closer-black.svg?react";
import { renderTextWithLineBreaks } from "@/utils/renderTextWithLineBreaks";
import { observer } from "mobx-react-lite";

interface WalletDialogModalProps {
  title?: string;
  content: JSX.Element;
  onClose?: () => void;
  onAction?: () => void;
  modalTitleColor?: string;
  headerTitle?: string | JSX.Element;
  isOpen?: boolean;
  buttonText?: string;
}

export const WalletDialog: React.FC<WalletDialogModalProps> = observer(
  ({
    isOpen = false,
    onClose,
    onAction,
    title,
    modalTitleColor,
    headerTitle,
    content,
    buttonText,
  }) => {
    const [closing, setClosing] = useState(false);

    const handleClose = () => {
      setClosing(true);
      setTimeout(() => {
        setClosing(false);
        onClose && onClose();
      }, 300);
    };

    const handleAction = () => {
      setClosing(true);
      setTimeout(() => {
        setClosing(false);
        onAction && onAction();
      }, 300);
    };

    return (
      <ReactModal
        ariaHideApp={false}
        overlayClassName={styles.modalOverlay}
        shouldCloseOnOverlayClick={true}
        onRequestClose={handleClose}
        className={`${styles.modalContainer} ${
          closing ? styles.modalClose : ""
        }`}
        isOpen={isOpen}
      >
        <div className={styles.modalContentWrapper}>
          <div className={styles.modalContent}>
            <div className={styles.moadlHeaderWrapper}>
              <p>{headerTitle}</p>
              <ModalCloser
                className={styles.modalCloser}
                onClick={handleClose}
              />
            </div>
            <div className={styles.textContainer}>
              <h2
                style={{
                  color: modalTitleColor,
                }}
                className={styles.modalTitle}
              >
                {title && renderTextWithLineBreaks(title)}
              </h2>
              <span>{content}</span>
            </div>
            <Button
              onClick={handleAction}
              label={buttonText ?? ""}
              styleType="primary"
              block={true}
            ></Button>
          </div>
        </div>
      </ReactModal>
    );
  }
);
